// Performance Monitor
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import store from "src/store";
function initDatadog() {
    console.log("Datadog::Initializing")
    var domain = "https://" + window.location.hostname
    console.log("Datadog::Setting Allowed Tracing Origins to: " + domain)
    // Configure Datadog monitor
    datadogRum.init({
        applicationId: '48a020d3-5b2f-4f5a-bf42-fca9264f76d7',
        clientToken: 'pub1e90cce4ec6c601492d0431f20b4084d',
        site: 'us3.datadoghq.com',
        service:'practice-dashboard',
        env:'production',
        // Specify a version number to identify the deployed version of your application in Datadog 
        version: '1.0.0',
        sampleRate: 100,
        premiumSampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackInteractions: true,
        trackViewsManually: true,
        defaultPrivacyLevel:'allow',
        allowedTracingOrigins: [domain],
        // beforeSend: (event, context) => {
            // if(event.type == 'resource' && event.resource.type == 'xhr') {
                // console.log('sending event to datadog: ', event)
                // console.log('with context: ', context)
                // console.log('xml respnse was: ', context.xhr.response)
                // event.context = {...event.context, returnedValue: context.xhr.response}
            // }
        // }
    }); 
    console.log("Datadog::Setting User Tags")
    // Add user info to datadog rum session
    datadogRum.setUser({
        name: store.getters["currentUser/getCurrentUsersFullName"],
        email: store.getters["currentUser/getCurrentUsersLogin"],
        practice: store.getters["currentUser/getCurrentUsersPractice"]
    })
    console.log("Datadog::Initializing Logging")
    datadogLogs.init({
        clientToken: 'pub1e90cce4ec6c601492d0431f20b4084d',
        site: 'us3.datadoghq.com',
        service: 'PracticeDashboard',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        forwardConsoleLogs: "all",
    })     
    console.log("Datadog::Starting Session Recording")
    // Enable Datadog monitor
    datadogRum.startSessionReplayRecording();
    console.log("Datadog::Finished Initialization")
}

export {
    initDatadog
}